import { Switch, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Header from './components/Common/Header';
import Footer from './components/Common/Footer';
import Homepage from './pages/Homepage';
import SupplierDashboard from './components/Supplier/SupplierDashboard';
import SupplierDetails from './components/Supplier/SupplierList';
import SupplierSignUp from './components/Supplier/SupplierSignUp';
import GetAllProductsOfSupplier from './components/Supplier/GetAllProductsOfSupplier';
import CreateNewProductBySupplier from './components/Supplier/CreateNewProductBySupplier';
import GetProductByIdFromSupplier from './components/Supplier/GetProductByIdFromSupplier';
import UpdateProductBySupplier from './components/Supplier/UpdateProductBySupplier';
import SupplierSignIn from './components/Supplier/SupplierSignIn';
import SupplierUpdateProfile from './components/Supplier/SupplierUpdateProfile';
import './App.css';
import GetMonthlyReport from './components/Admin/GetMonthlyReport';
import addCustomer from './components/Customer/AddCustomer';
import editCustomer from './components/Customer/UpdateCustomer';
import Tracking from './components/Tracking/Tracking';
import ProductsByCustomer from './components/Admin/ProductsByCustomer';
import SupplierAndProducts from './components/Admin/SupplierAndProducts';
import GetAvailableStock from './components/Admin/GetAvailableStock';
import CheckProductInStock from './components/Admin/CheckProductInStock';
import CartCustomer from './components/Customer/CartCustomer';
import CustomerLogin from './components/Customer/CustomerLogin';
import CustomerProduct from './components/Customer/CustomerProduct';
import Login from './components/Admin/auth/Login';
import Signup from './components/Admin/auth/Signup';
import { PrivateRoute } from './components/Auth/PrivateRoute';
import AdminHomePage from './pages/AdminHomePage';
import ViewTracking from './components/Tracking/ViewTracking';
import ProductList from './components/Product/ProductList';
import CreateNewProduct from './components/Product/CreateNewProduct';
import GetProductById_ from './components/Product/GetProductById_';
import UpdateProductBy from './components/Product/UpdateProductBy';
import GetProductByName from './components/Product/GetProductByName';
import Product from './components/Product/Product';
import PageNotFound from './pages/PageNotFound';

function App() {
    return (
        <>
            <Header />
            <div className="container-fluid">
                <Switch>
                    <Route exact path="/" component={Homepage} />

                    {/* Supplier routres */}
                    <Route exact path='/supplier/login' component={SupplierSignIn} />
                    <Route exact path="/supplier/signup" component={SupplierSignUp} />
                    <Route exact path="/supplierDetails" component={SupplierDetails} />
                    <Route exact path="/supplier/:supplierId/productDetails" component={GetAllProductsOfSupplier} />
                    <Route exact path="/supplier/:supplierId/addProduct" component={CreateNewProductBySupplier} />
                    <Route exact path="/supplier/:supplierId/getProduct/:productId" component={GetProductByIdFromSupplier} />
                    <Route exact path="/supplier/:supplierId/updateProduct/:productId" component={UpdateProductBySupplier} />
                    <Route exact path="/supplier/:supplierId/updateProfile" component={SupplierUpdateProfile} />
                    <Route exact path="/supplier/:supplierId" component={SupplierDashboard} />

                    {/* Customer routres */}
                    <Route exact path="/customer/add" component={addCustomer} />
                    <Route exact path="/customer/update/:customerId" component={editCustomer} />
                    <Route exact path="/customer/:customerId/cart" component={CartCustomer} />
                    <Route exact path="/customer/login" component={CustomerLogin} />
                    <Route exact path="/tracking/:id" component={ViewTracking} />
                    <Route exact path="/customer/:id/products" component={CustomerProduct} />

                    {/* Tacking routres */}
                    <Route exact path="/tracking" component={Tracking} />
                    {/* Products routres */}
                    <Route exact path="/get/:id" component={GetProductById_} />
                    <Route exact path="/product" component={Product} />
                    <Route exact path="/product/all" component={ProductList} />
                    <Route exact path="/product/create" component={CreateNewProduct} />
                    <Route exact path="/product/:id" component={GetProductById_} />
                    <Route exact path="/product/update/:id" component={UpdateProductBy} />
                    <Route exact path="/product/search/:name" component={GetProductByName} />
                    
                    {/* Admin routres */}
                    <PrivateRoute exact redirectPath={'/auth/login'} path="/admin" component={AdminHomePage} />
                    <PrivateRoute exact redirectPath={'/auth/login'} path="/admin/get-report" component={GetMonthlyReport} />
                    <PrivateRoute exact redirectPath={'/auth/login'} path="/admin/products-by-customer" component={ProductsByCustomer} />
                    <PrivateRoute exact redirectPath={'/auth/login'} path="/admin/supplier-and-products" component={SupplierAndProducts} />
                    <PrivateRoute exact redirectPath={'/auth/login'} path="/admin/available-stock" component={GetAvailableStock} />
                    <PrivateRoute exact redirectPath={'/auth/login'} path="/admin/check-stock" component={CheckProductInStock} />

                    {/* Auth Routes */}
                    <Route exact path="/auth/login" component={Login} />
                    <Route exact path="/auth/signup" component={Signup} />

                    <Route>
                        <PageNotFound />
                    </Route>
                </Switch>
            </div>
            <Footer />
        </>
    );
}

export default App;
